import {
  type InferOutput,
  minLength,
  object,
  pipe,
  string,
  number,
  optional,
  trim
} from 'valibot'

import { VALIDATION_MESSAGES } from '@/constants/common/validation.constants'

export const CreatePackageCategoryDtoSchema = object({
  dcId: optional(number(VALIDATION_MESSAGES.REQUIRED_ITEM)),
  code: pipe(string(), trim(), minLength(1, VALIDATION_MESSAGES.REQUIRED_ITEM)),
  name: pipe(string(), trim(), minLength(1, VALIDATION_MESSAGES.REQUIRED_ITEM)),
  shortName: pipe(
    string(),
    trim(),
    minLength(1, VALIDATION_MESSAGES.REQUIRED_ITEM)
  )
})

export type CreatePackageCategoryDto = InferOutput<
  typeof CreatePackageCategoryDtoSchema
>
